import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = {
  author: () => axios.get(`${API}/author`).then((r) => r.data),
  taxonomy: () => axios.get(`${API}/taxonomy`).then((r) => r.data),
  articles: () => axios.get(`${API}/articles`).then((r) => r.data),
  subscribe: (email) => axios.post(`${API}/subscribe`, { email }).then((r) => r.data),
  adminCheck: (token) =>
    axios.get(`${API}/admin/check`, { headers: { "X-Admin-Token": token } }).then((r) => r.data),
  patchArticle: (slug, body, token) =>
    axios.patch(`${API}/admin/articles/${slug}`, body, { headers: { "X-Admin-Token": token } }).then((r) => r.data),
  createShareList: (slugs) => axios.post(`${API}/sharelists`, { slugs }).then((r) => r.data),
  getShareList: (code) => axios.get(`${API}/sharelists/${code}`).then((r) => r.data),
  syncStatus: () => axios.get(`${API}/sync/status`).then((r) => r.data),
};

// Monospace theme codes + accent used across cards and filters
export const THEME_META = {
  "geopolitics-middle-east": { code: "GEO-01", color: "var(--t-geo)", short: "Geopolitics" },
  "political-islam": { code: "PSI-02", color: "var(--t-isl)", short: "Political Islam" },
  "moral-psychology": { code: "MPS-03", color: "var(--t-mps)", short: "Moral Psychology" },
  "mythology-history": { code: "MYT-04", color: "var(--t-myt)", short: "Mythology & History" },
  "media-disinformation": { code: "DIS-05", color: "var(--t-dis)", short: "Media & Disinfo" },
  "business-markets": { code: "FIN-06", color: "var(--t-fin)", short: "Business & Markets" },
};

export const SOURCE_META = {
  substack: { label: "Substack · Lapils", bg: "color-mix(in srgb, var(--s-substack) 13%, transparent)", border: "color-mix(in srgb, var(--s-substack) 42%, transparent)", text: "var(--s-substack)" },
  medium: { label: "Medium", bg: "color-mix(in srgb, var(--s-medium) 13%, transparent)", border: "color-mix(in srgb, var(--s-medium) 42%, transparent)", text: "var(--s-medium)" },
  x: { label: "X · Essay", bg: "color-mix(in srgb, var(--s-x) 13%, transparent)", border: "color-mix(in srgb, var(--s-x) 42%, transparent)", text: "var(--s-x)" },
  visegrad24: { label: "Visegrad24", bg: "color-mix(in srgb, var(--s-visegrad) 13%, transparent)", border: "color-mix(in srgb, var(--s-visegrad) 42%, transparent)", text: "var(--s-visegrad)" },
  ofcs: { label: "OFCS.Report", bg: "color-mix(in srgb, var(--s-ofcs) 13%, transparent)", border: "color-mix(in srgb, var(--s-ofcs) 42%, transparent)", text: "var(--s-ofcs)" },
  osservatorio: { label: "Osservatorio Mashrek", bg: "color-mix(in srgb, var(--s-osserv) 13%, transparent)", border: "color-mix(in srgb, var(--s-osserv) 42%, transparent)", text: "var(--s-osserv)" },
};

export const formatDate = (iso) => {
  const d = new Date(iso + "T00:00:00");
  return d.toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" });
};

export const formatRelative = (iso) => {
  if (!iso) return null;
  const then = new Date(iso);
  const s = Math.floor((Date.now() - then.getTime()) / 1000);
  if (s < 60) return "just now";
  const m = Math.floor(s / 60);
  if (m < 60) return `${m} min ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  if (d < 7) return `${d}d ago`;
  return then.toLocaleDateString("en-US", { month: "short", day: "numeric" });
};
